module.exports = __webpack_public_path__ + "static/media/icn_favourites_big.3a57d623.svg";